export default "__VITE_ASSET__BFJA8ozg__"